import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateFormat'
})
export class DateFormatPipe implements PipeTransform {

  transform(value: Date | string | number): string {
    if (!value) return '';

    let date: Date;

    if (typeof value === 'string' && value.includes('/') && value.split('/').length === 3) {
      const parts = value.split('/');
      // Check if it looks like DD/MM/YYYY (assuming DD is first if first part > 12)
      // or just assume DD/MM/YYYY if it's the ledger format
      const day = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10);
      const year = parseInt(parts[2], 10);
      
      if (month <= 12 && day <= 31) {
        date = new Date(year, month - 1, day);
      } else {
        date = new Date(value);
      }
    } else {
      date = new Date(value);
    }

    if (isNaN(date.getTime())) return '';

    const options: Intl.DateTimeFormatOptions = {
      month: 'short', // "Apr"
      day: '2-digit', // "22"
      year: 'numeric' // "2025"
    };

    return new Intl.DateTimeFormat('en-US', options).format(date);
  }

}
